import { inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { UserModel } from '../models/user.model';
import { jwtDecode } from 'jwt-decode';
import Keycloak from 'keycloak-js';

@Injectable({
	providedIn: 'root',
})
export class AuthService implements OnDestroy {
	private unsubscribe: Subscription[] = [];

	currentUser$: Observable<UserModel>;
	isLoading$: Observable<boolean>;
	isPayAdmin$: Observable<boolean>;
	currentUserSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	isLoadingSubject: BehaviorSubject<boolean>;
	isPayAdminSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	currentUser: UserModel | any;
	isPayAdmin!: boolean;

	get currentUserValue(): UserModel {
		return this.currentUserSubject.value;
	}

	set currentUserValue(user: UserModel) {
		this.currentUserSubject.next(user);
	}

	private router = inject(Router);
	private http = inject(HttpClient);
	private keycloakServ = inject(Keycloak);

	constructor() {
		{
			this.isLoadingSubject = new BehaviorSubject<boolean>(false);
			this.currentUserSubject = new BehaviorSubject<UserModel | any>(null);
			this.isPayAdminSubject = new BehaviorSubject<boolean>(false);
			this.currentUser$ = this.currentUserSubject.asObservable();
			this.isLoading$ = this.isLoadingSubject.asObservable();
			this.isPayAdmin$ = this.isPayAdminSubject.asObservable();
		}
	}

	logout() {
		this.router.navigate(['/']).then((r) => {
			this.keycloakServ.logout();
		});
	}

	async getUserByToken() {
		this.isLoadingSubject.next(true);
		try {
			const r = await this.keycloakServ.token;
			if (r) {
				const payload: any = jwtDecode(r);
				const user = new UserModel();
				user.uuid = payload.sub;
				user.firstname = payload.given_name;
				user.lastname = payload.family_name;
				user.name = payload.name;
				user.email = payload.email;
				user.language = payload.locale;
				if (payload.resource_access[environment.keycloak.clientId]) {
					user.role = payload.resource_access[environment.keycloak.clientId].roles.find((x: any) => x === environment.keycloak.adminRole);
					this.isPayAdminSubject.next(true);
					this.isPayAdmin = this.isPayAdminSubject.value;
				}
				this.currentUserSubject.next(user);
				this.currentUser = user;
				this.isLoadingSubject.next(false);
			} else {
				window.location.reload();
			}
		} catch (err) {
			window.location.reload();
		}
	}

	getUser(): UserModel {
		return this.currentUser;
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}
}
